import NotFound from './containers/NotFound';

export default {
    component: NotFound,
    childRoutes: [],
};



// WEBPACK FOOTER //
// ./src/routes/not-found/index.js